module.exports = __webpack_public_path__ + "media/newstyle/images/Facts-and-figures-7bc81ec0b84e79f569a514fdef030167.png";